import React, { useContext, useState } from 'react'
import { EventMetaContext } from '../SingleEvent'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import Alert from '@mui/material/Alert'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import ActionPopup from './ActionPopup'
import moment from 'moment'
import BigModal from '../../../../components/Modals/BigModal'
import API from '../../../../services/API'
import { DetailRow } from '../../../../components/Cards/DetailsBox'

const Actions = () => {
  const { eventMeta, setEventMeta } = useContext(EventMetaContext)
  const [openPopup, setOpenPopup] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={2}>
        <Stack>
          <Typography variant="title2" fontSize="1rem">
            Actions
          </Typography>
          <Box>
            <Button
              startIcon={<AddIcon />}
              size="small"
              color="anGreen"
              onClick={() => setOpenPopup(true)}
            >
              Add an Action
            </Button>
          </Box>
        </Stack>
      </Grid>
      <Grid item xs={12} lg={10}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell width="25%" sx={{ fontWeight: 'bold' }}>
                What
              </TableCell>
              <TableCell width="25%" sx={{ fontWeight: 'bold' }}>
                How
              </TableCell>
              <TableCell width="25%" sx={{ fontWeight: 'bold' }}>
                When
              </TableCell>
              <TableCell width="20%" sx={{ fontWeight: 'bold' }}>
                Person Responsible
              </TableCell>
              <TableCell width="5%" sx={{ fontWeight: 'bold' }}>
                Completed
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {eventMeta?.peaactions?.map((action) => (
              <TableRow
                key={action._id}
                sx={{ cursor: 'pointer' }}
                onClick={() => setSelectedRow(action)}
              >
                <TableCell>{action.what}</TableCell>
                <TableCell>{action.how}</TableCell>
                <TableCell>
                  {moment(action.when).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell width="10%">
                  <Stack direction="row" gap={1}>
                    <Avatar
                      src={action.personResponsible?.photograph}
                      sx={{ width: 24, height: 24 }}
                    />
                    <Typography>
                      {action.personResponsible.firstName}{' '}
                      {action.personResponsible.lastName}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell width="5%">
                  {action.completed && <CheckBoxIcon color="success" />}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <BigModal
            autoWidth
            open={!!selectedRow}
            onClose={() => setSelectedRow(null)}
          >
            <Stack gap={1}>
              <Typography variant="title2" fontSize="1rem">
                Action for {eventMeta.title}
              </Typography>
              <DetailRow label="What" value={selectedRow?.what} />
              <DetailRow label="How" value={selectedRow?.how} />
              <DetailRow
                label="When"
                value={moment(selectedRow?.when).format('DD/MM/YYYY')}
              />
              <DetailRow
                label="Responsible Person"
                value={`${selectedRow?.personResponsible?.firstName} ${selectedRow?.personResponsible?.lastName}`}
              />
              {selectedRow?.completed?.by ? (
                <Alert severity="info">
                  Marked as 'Completed' by {selectedRow.completed.by.firstName}{' '}
                  {selectedRow.completed.by.lastName} on{' '}
                  {moment(selectedRow.completed.when).format(
                    'Do MMM YYYY [at] HH:mm'
                  )}
                </Alert>
              ) : (
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => {
                    API.post('/events/markpeaactioncompleted', {
                      id: selectedRow._id,
                      eventID: eventMeta._id,
                    }).then((res) => {
                      if (res.status === 200) {
                        setEventMeta((prev) => ({
                          ...prev,
                          peaactions: res.data,
                        }))
                        setSelectedRow(null)
                      }
                    })
                  }}
                >
                  Mark as Complete
                </Button>
              )}
            </Stack>
          </BigModal>
        </Table>
      </Grid>
      <ActionPopup open={!!openPopup} onClose={() => setOpenPopup(false)} />
    </Grid>
  )
}

export default React.memo(Actions)
